import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export default function Gala2026Page() {
  const { locale, t, prefix } = useLanguage();
  const isZh = locale === 'zh';

  return (
    <div>
      {/* Hero */}
      <section
        style={{
          background: 'linear-gradient(135deg, #B71C1C 0%, #D32F2F 40%, #FF5252 100%)',
          color: '#fff',
          padding: '120px 0 80px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle at 20% 50%, rgba(255,215,0,0.15) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255,215,0,0.1) 0%, transparent 50%)',
          }}
        />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span
            style={{
              display: 'inline-block',
              background: 'rgba(255,255,255,0.15)',
              backdropFilter: 'blur(8px)',
              borderRadius: 24,
              padding: '6px 20px',
              fontSize: '0.85rem',
              fontWeight: 600,
              marginBottom: 20,
              letterSpacing: 1,
            }}
          >
            {isZh ? '2026 马年' : '2026 YEAR OF THE HORSE'}
          </span>
          <h1 style={{ fontSize: '3.5rem', fontWeight: 900, marginBottom: 12, lineHeight: 1.1 }}>
            {isZh ? '《盛宴》2026' : 'Festive Feast 2026'}
          </h1>
          <p style={{ fontSize: '1.5rem', fontWeight: 300, marginBottom: 8, opacity: 0.95 }}>
            {isZh ? '橙县华人马年春晚' : 'Lunar New Year Gala'}
          </p>
          <p style={{ fontSize: '1.1rem', opacity: 0.85, maxWidth: 600, margin: '0 auto 32px' }}>
            {isZh
              ? 'Chinese-American Association of Orange County'
              : '橙县华人协会 (CAAOC)'}
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href="https://www.thebarclay.org"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
              style={{
                background: '#fff',
                color: 'var(--red-dark)',
                fontWeight: 700,
                padding: '14px 32px',
                fontSize: '1rem',
                borderRadius: 'var(--radius-sm)',
              }}
            >
              {isZh ? '购票 - Barclay Theatre' : 'Buy Tickets - Barclay Theatre'}
            </a>
            <a
              href="https://shop.goairmart.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
              style={{
                background: 'rgba(255,255,255,0.15)',
                color: '#fff',
                border: '2px solid rgba(255,255,255,0.4)',
                fontWeight: 600,
                padding: '14px 32px',
                fontSize: '1rem',
              }}
            >
              {isZh ? '购票 - AirMart (Zelle/Venmo)' : 'Buy Tickets - AirMart (Zelle/Venmo)'}
            </a>
          </div>
        </div>
      </section>

      {/* Event Details */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'start' }}>
            <div>
              <h2 className="section-title" style={{ marginBottom: 24 }}>
                {isZh ? '活动详情' : 'Event Details'}
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                {[
                  {
                    icon: '\uD83D\uDCC5',
                    label: isZh ? '日期' : 'Date',
                    value: isZh ? '2026年1月30日 (星期五)' : 'Friday, January 30, 2026',
                  },
                  {
                    icon: '\u23F0',
                    label: isZh ? '时间' : 'Time',
                    value: isZh
                      ? '5:30-7:00pm 嘉年华 | 7:00-9:30pm 演出'
                      : '5:30-7:00 PM Carnival Booths | 7:00-9:30 PM Main Performance',
                  },
                  {
                    icon: '\uD83D\uDCCD',
                    label: isZh ? '地点' : 'Venue',
                    value: 'Irvine Barclay Theatre, 4242 Campus Dr, Irvine, CA 92612',
                  },
                  {
                    icon: '\uD83C\uDFAD',
                    label: isZh ? '主题' : 'Theme',
                    value: isZh ? '马年庆典 - 奔腾向前' : 'Year of the Horse - Galloping Forward',
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      display: 'flex',
                      gap: 16,
                      alignItems: 'flex-start',
                      padding: 16,
                      background: 'var(--gray-100)',
                      borderRadius: 'var(--radius-md)',
                    }}
                  >
                    <span style={{ fontSize: '1.5rem', flexShrink: 0 }}>{item.icon}</span>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>
                        {item.label}
                      </div>
                      <div style={{ fontWeight: 600, color: 'var(--gray-800)', fontSize: '1rem' }}>
                        {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="section-title" style={{ marginBottom: 24 }}>
                {isZh ? '关于盛宴' : 'About the Gala'}
              </h2>
              <div style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8 }}>
                <p style={{ marginBottom: 16 }}>
                  {isZh
                    ? '《盛宴》是橙县华人协会一年一度的农历新年春晚，是南加州华人社区最具影响力的文化盛事之一。自创办以来，盛宴已成为凝聚社区力量、传承中华文化的重要平台。'
                    : 'Festive Feast is CAAOC\'s annual Lunar New Year Gala, one of the most influential cultural events in the Southern California Chinese-American community. Since its inception, the Gala has become an important platform for uniting the community and preserving Chinese cultural heritage.'}
                </p>
                <p style={{ marginBottom: 16 }}>
                  {isZh
                    ? '2026马年春晚将呈现精彩纷呈的文艺演出，包括歌舞、器乐、武术、相声等节目。演出前的嘉年华环节设有美食摊位、文化体验和儿童活动。'
                    : 'The 2026 Year of the Horse Gala will feature spectacular performances including song, dance, instrumental music, martial arts, and comedy. The pre-show carnival includes food vendors, cultural experiences, and children\'s activities.'}
                </p>
                <p>
                  {isZh
                    ? '欢迎全家参与，共庆马年！无论您是华裔还是对中华文化感兴趣的朋友，都热忱欢迎您的到来。'
                    : 'The whole family is welcome to celebrate the Year of the Horse! Whether you are Chinese-American or simply interested in Chinese culture, we warmly welcome you to join us.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ticket Info */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 className="section-title">{isZh ? '购票方式' : 'How to Get Tickets'}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              {isZh ? '多种便捷购票渠道' : 'Multiple convenient ways to purchase'}
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {[
              {
                title: isZh ? 'AirMart (Zelle/Venmo)' : 'AirMart (Zelle/Venmo)',
                desc: isZh
                  ? '通过AirMart平台使用Zelle或Venmo在线购票'
                  : 'Purchase online via AirMart using Zelle or Venmo',
                url: 'https://shop.goairmart.com',
                color: 'var(--blue-accent)',
                bg: 'var(--blue-bg)',
              },
              {
                title: isZh ? 'Zeffy (信用卡)' : 'Zeffy (Credit Card)',
                desc: isZh
                  ? '通过Zeffy平台使用信用卡、Apple Pay等方式购票'
                  : 'Pay with credit card, Apple Pay, or bank transfer via Zeffy',
                url: '#',
                color: 'var(--green-accent)',
                bg: 'var(--green-bg)',
              },
              {
                title: isZh ? 'Barclay Theatre' : 'Barclay Theatre',
                desc: isZh
                  ? '直接通过Irvine Barclay Theatre官网购票'
                  : 'Purchase directly through Irvine Barclay Theatre website',
                url: 'https://www.thebarclay.org',
                color: 'var(--orange-accent)',
                bg: 'var(--orange-bg)',
              },
            ].map((option) => (
              <a
                key={option.title}
                href={option.url}
                target="_blank"
                rel="noopener noreferrer"
                className="card"
                style={{
                  textAlign: 'center',
                  padding: 32,
                  borderTop: `4px solid ${option.color}`,
                  textDecoration: 'none',
                }}
              >
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    background: option.bg,
                    margin: '0 auto 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                  }}
                >
                  🎟
                </div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: 8, color: 'var(--gray-900)' }}>
                  {option.title}
                </h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--gray-600)', lineHeight: 1.5 }}>
                  {option.desc}
                </p>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Past Gala Videos */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 className="section-title">{isZh ? '往届精彩回顾' : 'Past Gala Highlights'}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              {isZh ? '回顾历年春晚的精彩瞬间' : 'Relive the best moments from previous galas'}
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: 24 }}>
            {[
              {
                year: '2025',
                title: isZh ? '蛇年春晚' : 'Year of the Snake Gala',
                date: isZh ? '2025年1月12日' : 'January 12, 2025',
                link: prefix + '/gala/2025',
              },
              {
                year: '2024',
                title: isZh ? '龙年春晚' : 'Year of the Dragon Gala',
                date: isZh ? '2024年2月3日' : 'February 3, 2024',
                link: prefix + '/gala/2024',
              },
            ].map((gala) => (
              <Link
                key={gala.year}
                to={gala.link}
                className="card"
                style={{
                  display: 'flex',
                  gap: 20,
                  alignItems: 'center',
                  textDecoration: 'none',
                  padding: '24px 28px',
                }}
              >
                <div
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    background: 'var(--red-primary)',
                    color: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <span style={{ fontSize: '1.4rem', fontWeight: 900, lineHeight: 1 }}>{gala.year}</span>
                </div>
                <div>
                  <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: 'var(--gray-900)', marginBottom: 4 }}>
                    {isZh ? `《盛宴》${gala.year}` : `Festive Feast ${gala.year}`}
                  </h3>
                  <p style={{ fontSize: '0.9rem', color: 'var(--gray-500)' }}>
                    {gala.title} &middot; {gala.date}
                  </p>
                </div>
                <span style={{ marginLeft: 'auto', color: 'var(--red-primary)', fontSize: '1.2rem' }}>&#8594;</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Organization History */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            <h2 className="section-title" style={{ textAlign: 'center', marginBottom: 24 }}>
              {isZh ? '关于橙县华人协会' : 'About CAAOC'}
            </h2>
            <div style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8, textAlign: 'center' }}>
              <p style={{ marginBottom: 16 }}>
                {isZh
                  ? '橙县华人协会（CAAOC）自2010年成立以来，从最初在老年活动中心举办小型聚会，逐步发展成为服务整个橙县华人社区的综合性组织。协会下设华人家长会、阳光亲子俱乐部等多个分支团体。'
                  : 'Since its founding in 2010, the Chinese-American Association of Orange County (CAAOC) has grown from hosting small gatherings at senior centers into a comprehensive organization serving the entire Orange County Chinese-American community. CAAOC includes affiliated groups such as the Chinese Parents Association and the Sunshine Parent-Child Club.'}
              </p>
              <p>
                {isZh
                  ? '《盛宴》春晚是协会的标志性活动，每年在Irvine Barclay Theatre隆重举行，已成为南加州华人社区不可或缺的文化盛事。'
                  : 'The Festive Feast Gala is CAAOC\'s signature event, held annually at the Irvine Barclay Theatre. It has become an indispensable cultural celebration for the Southern California Chinese-American community.'}
              </p>
            </div>
            <div style={{ textAlign: 'center', marginTop: 32 }}>
              <Link to={prefix + '/about'} className="btn btn-outline" style={{ padding: '12px 32px' }}>
                {isZh ? '了解更多' : 'Learn More About Us'}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .section-title { font-size: 1.8rem !important; }
        }
      `}</style>
    </div>
  );
}
